var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5414_126253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7578 18C19.7578 18.9708 18.9708 19.7578 18 19.7578C17.0292 19.7578 16.2422 18.9708 16.2422 18C16.2422 17.0292 17.0292 16.2422 18 16.2422C18.9708 16.2422 19.7578 17.0292 19.7578 18Z",
    fill: "#28475C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9688 12.6875H15.0312C13.7388 12.6875 12.6875 13.7388 12.6875 15.0312V20.9688C12.6875 22.2612 13.7388 23.3125 15.0312 23.3125H20.9688C22.2612 23.3125 23.3125 22.2612 23.3125 20.9688V15.0312C23.3125 13.7388 22.2612 12.6875 20.9688 12.6875ZM18 20.9297C16.3846 20.9297 15.0703 19.6154 15.0703 18C15.0703 16.3846 16.3846 15.0703 18 15.0703C19.6154 15.0703 20.9297 16.3846 20.9297 18C20.9297 19.6154 19.6154 20.9297 18 20.9297ZM21.3594 15.2266C21.0357 15.2266 20.7734 14.9643 20.7734 14.6406C20.7734 14.317 21.0357 14.0547 21.3594 14.0547C21.683 14.0547 21.9453 14.317 21.9453 14.6406C21.9453 14.9643 21.683 15.2266 21.3594 15.2266Z",
    fill: "#28475C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7266 8H13.2734C10.3657 8 8 10.3657 8 13.2734V22.7266C8 25.6343 10.3657 28 13.2734 28H22.7266C25.6343 28 28 25.6343 28 22.7266V13.2734C28 10.3657 25.6343 8 22.7266 8ZM24.4844 20.9688C24.4844 22.9072 22.9072 24.4844 20.9688 24.4844H15.0312C13.0928 24.4844 11.5156 22.9072 11.5156 20.9688V15.0312C11.5156 13.0928 13.0928 11.5156 15.0312 11.5156H20.9688C22.9072 11.5156 24.4844 13.0928 24.4844 15.0312V20.9688Z",
    fill: "#28475C"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#EBF0F3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5414_126253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramicon);
export default __webpack_public_path__ + "static/media/instagramicon.22919459282e46d5a07fa35627277aa6.svg";
export { ForwardRef as ReactComponent };